import React from 'react'
import styled from '@emotion/styled'
import {TranslatedLOVItem} from '@findhotel/sapi'
import {FacilitiesSection} from 'components/Accommodation/FacilitiesSection'
import {GroupedFacilities} from 'types/Hotel'

import {cssTheme} from '@vio/atlas/themes'

const Spacer = styled.div`
  height: ${cssTheme.layout.spacing.s700};
`

interface Props {
  groupedFacilities: GroupedFacilities[]
  topFacilities: TranslatedLOVItem[]
}
export const FacilitiesPopupContent = ({
  groupedFacilities,
  topFacilities
}: Props) => {
  if (!topFacilities) return null

  return (
    <>
      <FacilitiesSection
        groupedFacilities={groupedFacilities}
        topFacilities={topFacilities}
      />
      <Spacer />
    </>
  )
}
